import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const Card = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {{ src: string, alt: string } | (() => JSX.Element)} props.image
 * @param {any} props.children
 * @param {any} props.className
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Card({
  image,
  children,
  className,
  ...props
}, ref) {
  const cardClass = classNames(["overflow-hidden", "bg-white", "shadow-lg"], className);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cardClass,
    ref: ref
  }), typeof image === "function" ? image() : image && image.src ? /*#__PURE__*/React.createElement("img", {
    className: "w-full h-40 object-cover",
    src: image.src,
    alt: image.alt
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "px-6 py-4"
  }, children));
});
Card.propTypes = {
  image: PropTypes.any,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};